import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleJobNimbusAuthError, push } from 'actions';
import {
  Modal,
  Panel,
  Row,
  Col,
  ButtonGroup,
  Button
} from 'react-bootstrap';
import { Link } from 'react-router';


class JNAuthWarning extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Modal
        show={this.props.jobnimbus_auth_error == true}
        onHide={this.props.toggleJobNimbusAuthError}
        >
        <div className='panel panel-danger'>
          <div className='panel-heading'>
            <h3 className='panel-title'>Error!</h3>
          </div>
        </div>
        <Modal.Body>
          <p>
            Your Job Nimbus account has not authorized our request to maintain the integration{' '}
            with the currently supplied Job Nimbus api key. This usually{' '}
            means you have either expired, or cancelled your Job Nimbus 'Professional' subsctiption.{' '}
            <br /><br />
            You must either cancel the integration between your Hail Trace and Job Nimbus accounts from{' '}
            our <Link to='integrations'>Integrations</Link> page, or log in to your{' '}
            <a href='https://www.jobnimbus.com/'>Job Nimbus</a> account to resolve the issue.
          </p>
          <hr className='dotted short'/>
          <Row>
            <Col md={12} xs={12}>
              <ButtonGroup>
                <Button bsStyle='default' onClick={() => this.props.push('dashboard/summary')}>Go To Dashboard</Button>
                <Button bsStyle='default' onClick={() => this.props.push('settings/integrations')}>Go To Integrations</Button>
              </ButtonGroup>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = ({ integrations: { jobnimbus_auth_error } }) => ({ jobnimbus_auth_error });

export default connect(mapStateToProps, { toggleJobNimbusAuthError, push })(JNAuthWarning);



// WEBPACK FOOTER //
// ./src/browser/components/settings/integrations/jobnimbus/jn-auth-warning.js